import React from 'react';
import './css/LocationAndTVSection.css';

export default function LocationAndTVSection({ data, youtubeVideoId }) {
  const titulo = data?.titulo || 'TRANSMISSÃO & LOCALIZAÇÃO';
  const tvTitulo = data?.tvTitulo || 'Assista à TV ADCN';
  const tvTexto = data?.tvTexto || 'Acompanhe nossos cultos e transmissões ao vivo no canal oficial da ADCN no YouTube.';
  const instagramLink = data?.instagramLink || 'https://instagram.com';
  const facebookLink = data?.facebookLink || 'https://facebook.com';
  const videoId = youtubeVideoId || 'QLEyzNunHKo';
  
  console.log('[LocationAndTVSection] Props recebidas:', { youtubeVideoId });
  console.log('[LocationAndTVSection] videoId final que será usado:', videoId);

  return (
    <section className="location-tv-section">
      <h2 className="section-title">{titulo}</h2>

      <div className="tv-info">
        <div className="tv-video">
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?si=liWAtKS7PrTHG1vN`}
            title="TV ADCN ao vivo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
        <div className="tv-details">
          <h3>{tvTitulo}</h3>
          <p>{tvTexto}</p>
          <p>Siga nossas redes sociais</p>
          <div className="social-buttons">
            {instagramLink && (
              <a href={instagramLink} target="_blank" rel="noreferrer">Instagram</a>
            )}
            {facebookLink && (
              <a href={facebookLink} target="_blank" rel="noreferrer">Facebook</a>
            )}
          </div>
        </div>
      </div>

      <div className="map-container">
        <iframe
          title="Mapa ADCN"
          width="100%"
          height="400"
          style={{ border: 0, borderRadius: '12px' }}
          loading="lazy"
          allowFullScreen
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBfxp3VAmfGk6dwG7CW3SXwqhopT5iKF9g&q=-17.7502495,-48.629552&zoom=15"
        />
      </div>
    </section>
  );
}
